<template>
  <div class="edrea_tm_section" id="about">
    <div class="section_inner">
      <div class="edrea_tm_about">
        <div class="left">
          <div class="image">
            <img src="img/thumbs/1-1.jpg" alt="" />
            <div class="main" data-img-url="img/about/1.jpg"></div>
          </div>
        </div>
        <div class="right">
          <div class="short">
            <h3 class="name">DevMedia <span class="coloring">Labs</span></h3>
            <h3 class="job">
              <AnimationText />
            </h3>
          </div>
          <div class="text">
            <p>
              At <span>DevMediaLabs</span>, we're more than just a 
              creative team—we're innovators. From building mobile 
              games that captivate players, to designing web platforms 
              that generate revenue through ads and affiliates, 
              we craft digital experiences with impact. 
              Our expertise in SEO, AEO, and growth strategies 
              helps businesses get discovered, while our web apps and eCommerce 
              solutions turn ideas into results.
            </p>
          </div>
          <!--
          <div class="edrea_tm_button" id="aboutPopup">
            <a href="#">Learn More</a>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimationText from "./AnimationText.vue";
export default {
  name: `AboutComponent`,
  data() {
    return {
      open: false,
    };
  },
  components: {
    AnimationText,
  },
};
</script>

<style scoped>
.edrea_tm_modalbox {
  top: -90px;
}
</style>
